type TVideoFrame = { left: number; top: number; width: number; height: number };

function getVideoFrame(container: HTMLElement, video: HTMLElement): TVideoFrame | null {
  const containerRect = container.getBoundingClientRect();
  const videoRect = video.getBoundingClientRect();
  if (!videoRect.width || !videoRect.height) return null;

  return {
    left: videoRect.left - containerRect.left,
    top: videoRect.top - containerRect.top,
    width: videoRect.width,
    height: videoRect.height,
  };
}

export type { TVideoFrame };
export { getVideoFrame };
